export default "__VITE_PUBLIC_ASSET__26c9769e__"